module.exports = __webpack_public_path__ + "assets/img/btn-view-faa28a8f.png";